import { TFunction } from 'i18next';
import { ISummaryErrors } from '../models';

export const getErrorsNames = (errors: ISummaryErrors, t: TFunction) =>
	Object.keys(errors).reduce((text, error) => {
		const errorText = t(`error_names.${error}`);
		return text ? `${text}, ${errorText}` : errorText;
	}, '');
